import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faStar,
    faEnvelope,
    faBolt,
} from "@fortawesome/free-solid-svg-icons";

import "./Why_Choose_Us.css";

const whyChooseUsItems = [
    {
        icon: faCheck,
        title: "Government Approved",
        description:
            "Fully registered with MEA and compliant with all government regulations and standards.",
    },
    {
        icon: faStar,
        title: "Proven Track Record",
        description:
            "Over 1000 successful placements with a 100% client satisfaction rate across 50+ countries.",
    },
    {
        icon: faEnvelope,
        title: "Expert Team",
        description:
            "Experienced professionals dedicated to understanding your needs and delivering results.",
    },
    {
        icon: faBolt,
        title: "Quick Processing",
        description:
            "Fast-track applications with efficient documentation and rapid placement timelines.",
    },
];

const WhyChooseUs = () => {
    return (
        <section className="why_choose_us">
            <div className="container">
                <div className="row">
                    <div className="col xs-12 md-10 lg-8">
                        <div className="why_choose_us_heading">
                            <h2 className="title">
                                Why Choose Us
                            </h2>

                            <p className="sub_title">
                                Industry-leading recruitment with unmatched expertise and success rate
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {whyChooseUsItems.map((item, index) => (
                        <div className="col-12 col-md-6 d-flex" key={index}>
                            <div className="why_choose_us_item">
                                <div className="why_choose_us_icon">
                                    <FontAwesomeIcon icon={item.icon} />
                                </div>

                                <div className="why_choose_us_details">
                                    <h3 className="item_title">
                                        {item.title}
                                    </h3>

                                    <p className="item_text">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;